export const VARIANTS = {
    default: 'default',
    primary: 'primary',
    info: 'info',
    ghost: 'ghost',
    outline: 'outline',
    danger: 'danger',
}

export const TAGS = {
    a: 'a',
    button: 'button',
}

export const SIZES = {
    M: 'M',
    S: 'S',
}

export const getPalette = (variant, disabled) => {
    switch (variant) {
    case VARIANTS.default:
        return {
            fontColor: 'dark',
            bgColor: disabled ? 'grey' : 'white',
            borderColor: disabled ? 'grey' : 'white',
        }
    case VARIANTS.primary:
        return {
            fontColor: 'white',
            bgColor: disabled ? 'grey' : 'green',
            borderColor: disabled ? 'grey' : 'green',
        }
    case VARIANTS.info:
        return {
            fontColor: 'white',
            bgColor: disabled ? 'grey' : 'blue',
            borderColor: disabled ? 'grey' : 'blue',
        }
    case VARIANTS.ghost:
        return {
            fontColor: 'white',
            bgColor: disabled ? 'grey' : 'transparent',
            borderColor: disabled ? 'grey' : 'white',
        }
    case VARIANTS.outline:
        return {
            fontColor: 'green',
            bgColor: disabled ? 'grey' : 'transparent',
            borderColor: disabled ? 'grey' : 'green',
        }
    case VARIANTS.danger:
        return {
            fontColor: 'white',
            bgColor: disabled ? 'grey' : 'red',
            borderColor: disabled ? 'grey' : 'red',
        }
    default:
        throw new Error(`Unknown variant: ${variant}`)
    }
}

export const getPixelsFromSize = (size) => {
    switch (size) {
    case SIZES.M:
        return {
            height: 44,
            minWidth: 100,
            borderRadius: 25,
            paddingHorizontal: 12,
            textSize: 'XS',
        }
    case SIZES.S:
        return {
            height: 34,
            minWidth: 80,
            borderRadius: 3,
            paddingHorizontal: 6,
            textSize: 'XXS',
        }
    default:
        throw new Error('Unknown size')
    }
}
